import React from 'react';
import { useEsosa } from './EsosaContext';
const LanguageSelector: React.FC = () => {
  const {
    currentLanguage,
    setLanguage
  } = useEsosa();
  const languages = [{
    id: 'english',
    name: 'English'
  }, {
    id: 'pidgin',
    name: 'Pidgin'
  }, {
    id: 'edo',
    name: 'Edo'
  }];
  return <div className="flex space-x-2 mb-2" data-id="element-269">
      {languages.map(lang => <button key={lang.id} onClick={() => setLanguage(lang.id as 'english' | 'pidgin' | 'edo')} className={`px-3 py-1 text-xs rounded-full transition-colors ${currentLanguage === lang.id ? 'bg-green-700 text-white' : 'bg-white text-green-700 border border-green-300 hover:bg-green-100'}`} data-id="element-270">
          {lang.name}
        </button>)}
    </div>;
};
export default LanguageSelector;